import { h as o } from "vue";
import { s as t } from "./svgIconFactory-Dn0WJdb3.js";
o(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28.5 20.243" },
  o("g", { fill: "none", stroke: "#222", "stroke-linecap": "round", "stroke-width": "3" }, [
    o("path", { "stroke-linejoin": "round", d: "m9.501 2.121-8 8 8 8" }),
    o("path", { d: "M2 10.121h25" })
  ])
);
const s = (r) => t({
  props: r,
  svgNodeAttrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28.5 20.243" },
  childrenNodes: o(
    "g",
    {
      fill: "none",
      stroke: r.strikeColor ?? "#222",
      "stroke-linecap": "round",
      "stroke-width": "3"
    },
    [
      o("path", { "stroke-linejoin": "round", d: "m9.501 2.121-8 8 8 8" }),
      o("path", { d: "M2 10.121h25" })
    ]
  )
});
export {
  s as ArrowIndicatorIcon
};
